/**
 * PlantApi
 * 1.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
    headers: {},
    baseUrl: "/",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type Organization = {
    id: number;
    name?: string | null;
    industry?: string | null;
    active: boolean;
    stripeCustomerId?: string | null;
    createdOn?: string | null;
    createdBy?: string | null;
    lastUpdatedOn?: string | null;
    lastUpdatedBy?: string | null;
    recordVer?: number | null;
    unifiedLoginOrganizationId?: string | null;
};
export type FacilitySetupStatus = "unknown" | "new" | "dataImportInProgress" | "setupComplete";
export type ProductCategoryDto = {
    id: number;
    description: string;
};
export type InfrastructureCleaningMethod = "invalid" | "dailyWet" | "downDayWet" | "downDayDry" | "dailyDry";
export type CleaningRoleDto = {
    id: number;
    category: string;
    name: string;
};
export type SkillTypeDto = {
    code: string;
    skillLevel?: number | null;
    name: string;
    active: boolean;
    trainingRequired: boolean;
    certificationLength: number;
    isDefault: boolean;
    trainings: string[];
    isTrainingRequired: boolean;
    inUse: boolean;
};
export type CorpCatDto = {
    "number": number;
    name: string;
    active: boolean;
    inUse: boolean;
};
export type FacilityDto = {
    id: number;
    name?: string | null;
    organizationId?: number | null;
    organization?: (Organization) | null;
    setupStatus: FacilitySetupStatus;
    minimumRoomsAreas: number;
    maximumRoomsAreas: number;
    minimumBuildings: number;
    maximumBuildings: number;
    productCategories: ProductCategoryDto[];
    infrastructureCleaningMethods: InfrastructureCleaningMethod[];
    productionDryCleaning: boolean;
    productionWetCleaning: boolean;
    useAllergens: boolean;
    useChangeOvers: boolean;
    allergensDifferentPerProduct: boolean;
    active: boolean;
    timeZone?: string | null;
    infrastructureCleaningRoles: CleaningRoleDto[];
    equipmentCleaningRoles: CleaningRoleDto[];
    routineCleaningRoles: CleaningRoleDto[];
    janitorialCleaningRoles: CleaningRoleDto[];
    changeoverCleaningRoles: CleaningRoleDto[];
    skillTypes: SkillTypeDto[];
    corporateCategories: CorpCatDto[];
};
export type DataStatus = "success" | "notValid" | "exception" | "error" | "inUse" | "notFound" | "noChange" | "inProgress" | "invalidPage" | "notAuthorized" | "duplicateEntity" | "noContent" | "accepted";
export type ErrorResponse = {
    message: string;
    kind: DataStatus;
    exception?: string | null;
    stackTrace?: string | null;
    exceptionType?: string | null;
    innerException?: string | null;
    validationErrors?: {
        [key: string]: string[];
    } | null;
};
export type ValidationProblemDetails = {
    "type"?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors: {
        [key: string]: string[];
    };
    [key: string]: any;
};
export type FacilityListDto = {
    id: number;
    name: string;
    organizationId: number;
    organization: Organization;
    setupStatus: FacilitySetupStatus;
};
export type TimeZoneDto = {
    timeZone: string;
};
export type TimeZoneInfo = {
    id: string;
    hasIanaId: boolean;
    displayName: string;
    standardName: string;
    daylightName: string;
    baseUtcOffset: string;
    supportsDaylightSavingTime: boolean;
};
export type FacilityProductCategoriesDto = {
    productCategories: ProductCategoryDto[];
    setupStatus: FacilitySetupStatus;
};
export type FacilityRoomsAndLayoutDto = {
    minimumRoomsAreas: number;
    maximumRoomsAreas: number;
    minimumBuildings: number;
    maximumBuildings: number;
    setupStatus: FacilitySetupStatus;
};
export type FacilityInfrastructureCleaningDto = {
    infrastructureCleaningMethods: InfrastructureCleaningMethod[];
    infrastructureCleaningRoles: CleaningRoleDto[];
    setupStatus: FacilitySetupStatus;
};
export type UserModel = {
    userName: string;
    mobileUserName: string;
    email: string;
    firstName: string;
    lastName: string;
    userId: number;
    organizationId: number;
    isValidForPlant: boolean;
};
export type IndustryLookupView = {
    id: number;
    name: string;
};
export type ExpirationTypeEnum = "none" | "day" | "week" | "month" | "year";
export type SubscriptionPriceDto = {
    id: number;
    name: string;
    price: number;
    isActive: boolean;
    expirationLength: number;
    expirationType: ExpirationTypeEnum;
    releaseDate: string;
    popular: boolean;
    trialPeriodDays: number;
    discountedPrice: number;
};
export type SubscriptionPlanDto = {
    slug: string;
    facilityCap: number;
    equipAreaCap: number;
    canRenew: boolean;
    prices: SubscriptionPriceDto[];
    sortOrder: number;
    isFree: boolean;
    releaseDate: string;
    isAvailable: boolean;
};
export type CheckoutDto = {
    subscriptionId: number;
};
export type CheckoutSessionDto = {
    clientSecret: string;
    sessionId: string;
};
export type CheckoutStatusDto = {
    checkoutSessionId: string;
    status: string;
    paymentStatus: string;
    priceId: string;
    subscriptionId: number;
    subscriptionSlug: string;
};
export function getFacilityList({ page, pageSize }: {
    page?: number;
    pageSize?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: FacilityDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities${QS.query(QS.explode({
        page,
        pageSize
    }))}`, {
        ...opts
    });
}
export function createFacility(facilityDto: FacilityDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: FacilityDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/facilities", oazapfts.json({
        ...opts,
        method: "POST",
        body: facilityDto
    }));
}
export function getCondensedFacilityList({ page, pageSize }: {
    page?: number;
    pageSize?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: FacilityListDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/CondensedList${QS.query(QS.explode({
        page,
        pageSize
    }))}`, {
        ...opts
    });
}
export function getFacility(id: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: FacilityDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/${encodeURIComponent(id)}`, {
        ...opts
    });
}
export function updateFacility(id: number, facilityDto: FacilityDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: FacilityDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/${encodeURIComponent(id)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: facilityDto
    }));
}
export function deleteFacility(id: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: FacilityDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/${encodeURIComponent(id)}`, {
        ...opts,
        method: "DELETE"
    });
}
export function setTimeZone(id: number, timeZoneDto: TimeZoneDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: TimeZoneInfo;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/${encodeURIComponent(id)}`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: timeZoneDto
    }));
}
export function patchApiSetupFacilitiesByIdProductcategories(id: number, facilityProductCategoriesDto: FacilityProductCategoriesDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/${encodeURIComponent(id)}/productcategories`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: facilityProductCategoriesDto
    }));
}
export function patchApiSetupFacilitiesByIdRoomsandlayout(id: number, facilityRoomsAndLayoutDto: FacilityRoomsAndLayoutDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/${encodeURIComponent(id)}/roomsandlayout`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: facilityRoomsAndLayoutDto
    }));
}
export function patchApiSetupFacilitiesByIdInfrastructurecleaning(id: number, facilityInfrastructureCleaningDto: FacilityInfrastructureCleaningDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/${encodeURIComponent(id)}/infrastructurecleaning`, oazapfts.json({
        ...opts,
        method: "PATCH",
        body: facilityInfrastructureCleaningDto
    }));
}
export function addUserToFacility(userid: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/${encodeURIComponent(userid)}`, {
        ...opts,
        method: "POST"
    });
}
export function removeUserFromFacility(userId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/removeuser/${encodeURIComponent(userId)}`, {
        ...opts,
        method: "DELETE"
    });
}
export function getFacilityUsers({ page, pageSize }: {
    page?: number;
    pageSize?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserModel[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/facilities/users${QS.query(QS.explode({
        page,
        pageSize
    }))}`, {
        ...opts
    });
}
/**
 * Number and Name for Industries for use in most Drop Downs
 */
export function getIndustryLookupList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: IndustryLookupView[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/industrylookuplist", {
        ...opts
    });
}
export function getAvailableSubscriptions(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: SubscriptionPlanDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/subscriptions", {
        ...opts
    });
}
export function createCheckoutSession(checkoutDto: CheckoutDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: CheckoutSessionDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/subscriptions/checkout", oazapfts.json({
        ...opts,
        method: "POST",
        body: checkoutDto
    }));
}
export function checkSubscriptionStatus(sessionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: CheckoutStatusDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/subscriptions/status/${encodeURIComponent(sessionId)}`, {
        ...opts
    });
}
export function createPaymentMethodSetupSession(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: CheckoutSessionDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/subscriptions/payment-method", {
        ...opts,
        method: "POST"
    });
}
export function checkPaymentMethodSetupStatus(sessionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/subscriptions/payment-method/status/${encodeURIComponent(sessionId)}`, {
        ...opts
    });
}
